import styled from 'styled-components'

export const SameSupportCount = styled.div`
  width: 50px;
  height: 20px;
  background-color: ${props => props.bgColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: relative;
  top: -5px;
  border-radius: 5px;
  -webkit-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.75);
  cursor: pointer;
`

export const MarkerContainer = styled.div`
  position: relative;
  height: 40px;
  width: 40px;
  cursor: pointer;
`

export const MarkerCount = styled.div`
  text-align: center;
  height: 32px;
  width: 32px;
  color: white;
  display: block;
  font-weight: bold;
  border-radius: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: ${props => props.bgColor};
  &:hover {
    width: 26px;
    height: 26px;
  }
`

export const MarkerCountBackdrop = styled.div`
  background-color: rgba(77, 136, 203, 0.2);
  height: 45px;
  width: 45px;
  text-align: center;
  position: absolute;
  bottom: -25%;
  left: 0%;
  display: block;
  font-weight: bold;
  border-radius: 25px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-shadow: 0.125em 0.125em 0.125em 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0.125em 0.125em 0.125em 0px rgba(0, 0, 0, 0.75);
`



// WEBPACK FOOTER //
// ./src/components/Map/styles/ClustersStyles.js